<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='3'></LeftNav>
      <div class="customer-mail-detail-display">
        <h2>メール送信履歴詳細</h2>
        <div class="customer-mail-detil-box">
          <div class="customer-mail-list-box">
            <h3>送信対象</h3>
            <table>
              <thead>
                <tr>
                  <th v-for="item in list_head" :key="item.id" :class="item.class">{{ item.title }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in list.customers">
                  <tr :key="item.id" :class="{'unsubscribe': item.deleted_date !== ''}">
                    <td class="td-id">{{ item.id }}</td>
                    <td class="td-name">
                      <span v-if="item.deleted_date !== ''">[退会]</span>
                      <span>{{ item.customer_name }}</span>
                    </td>
                    <td class="td-mail"><p>{{ item.mail }}</p></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="mail-info-box">
            <h3>送信情報</h3>
            <p class="title">送信日時</p>
            <div class="last_send_date">{{ list.last_send_date }}</div>
            <p class="title">件名</p>
            <div class="subject">{{ list.subject }}</div>
            <p class="title">本文</p>
            <div class="content" v-html="new_line_br(list.content)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';

export default {
  name: 'manageDefault',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      send_mail_history_detail_id: 0,
      list: [],
      list_head: [
        {id: 1, title: '会員ID', class: 'th-id'},
        {id: 2, title: '会員名', class: 'th-name'},
        {id: 3, title: 'メールアドレス', class: 'th-mail'},
      ],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.send_mail_history_detail_id = this.$route.params.id;
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    let ld = new this.$loader(this);
    ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token'],
      send_mail_history_detail_id: this.send_mail_history_detail_id});
    ld._post_cb_f = this.send_mail_history_detail_get_cb;
    ld._load_start('manage/send_mail_history_detail_get.php');
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    send_mail_history_detail_get_cb (data) {
      if (data.res === 1) {
        this.list = data.data.list;
      } else {
        this.$alert('alert', `エラーコード：${data.data.res}`);
      }
    },
    new_line_br (content) {
      if (content === undefined || content === null) {
        return '';
      }
      return content.replace(/\r|\n|\r\n/g, '<br>');
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .customer-mail-detail-display {
    min-width: 1108px;
    padding: 16px;
    flex: 1;
    h2 {
      margin-bottom: 20px;
    }
    .customer-mail-detil-box {
      display: flex;
      justify-content: center;
      .customer-mail-list-box {
        width: 570px;
        table {
          margin: 0 auto;
          thead {
            display:block;
            tr {
              background-color: $manage-table-head-bg-color;
            }
            th {
              border: 1px solid $manage-table-border-color;
              border-bottom: none;
              padding: 5px 0;
            }
            th.th-id {
              width: 80px;
            }
            th.th-name {
              width: 160px;
              padding: 0 10px;
            }
            th.th-mail {
              width: 270px;
            }
          }
          tbody{
            display:block;
            overflow-y:scroll;
            height: calc(100vh - 164px);
            min-height: 320px;
            width: 552px;
            tr.unsubscribe {
              background-color: #efefef;
            }
            td {
              padding: 10px 0;
              border: 1px solid $manage-table-border-color;
            }
            td.td-id {
              width: 80px;
            }
            td.td-name {
              width: 160px;
              text-align: left;
              padding: 0 10px;
            }
            td.td-mail {
              text-align: left;
              width: 270px;
              p {
                margin-left: 10px;
                word-break: break-all;
              }
            }
          }
        }
      }
      .mail-info-box {
        margin-left: 20px;
        width: 100%;
        max-width: 900px;
        .title {
          text-align: left;
          font-weight: bold;
          padding: 3px 0 3px 0;
        }
        .last_send_date {
          text-align: left;
          margin: 0 0 10px 10px;
        }
        .subject {
          margin-bottom: 10px;
          padding: 5px;
          height: 50px;
          background-color: #f4f4e5;
          text-align: left;
          overflow: hidden;
        }
        .content {
          height: calc(100vh - 338px);
          padding: 5px;
          text-align: left;
          overflow-y: scroll;
          background-color: #f4f4e5;
        }
      }
    }
  }
}
</style>
